import React from 'react';
import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core"
import "../assets/css/main.css";
import ProduktDevMobile from "./page/wizard/step-antrag/produkt/ProduktDevMobile";
import AgenturAvatar from "./agentur/avatar/AgenturAvatar";
import Images from "../assets/images";

const useStyles = makeStyles((theme: Theme) => createStyles({
    header: {
        minHeight: 100,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            minHeight: 50
        },
        backgroundColor: '#FFF',
    },
    headerLogoGrid: {
        minWidth: 180
    },
    headerLogo: {
        height: 50,
        paddingTop: 25,
        paddingBottom: 25,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            height: 30,
            paddingTop: 10,
            paddingBottom: 10,
        },

        width: 160,
        paddingLeft: 20,
        paddingRight: 20
    },
    headerLogoImage: {
        // volle Hoehe
        height: '100%',
        width: 'auto',
    },
    dogoramaLogoImage: {
        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            height: 30,
        },
        height: '63px',
        width: 'auto',
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 20
    },
    headerDogorama: {
        width: 'auto',
    }

}));


const AppHeaderMobile: React.FC<{ showProduktInfos: boolean, isDogorama: boolean }> = ({ showProduktInfos, isDogorama }) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Grid container justifyContent='space-between' className={classes.header} spacing={0}>
                <Grid item xs={4} sm={4} className={classes.headerLogoGrid}>
                    <div className={classes.headerLogo}>
                        <img src={Images.logo} className={classes.headerLogoImage} alt="RheinLand Versicherungsgruppe Logo"></img>
                    </div>
                </Grid>
                {!isDogorama && <Grid item xs={2} sm={8} container justifyContent='flex-end'>
                    <AgenturAvatar />
                </Grid>}
                {isDogorama && 
                        <Grid item xs={2} sm={8} container justifyContent='flex-end'>
                            <div className={classes.headerDogorama}>
                                <img src={Images.dogoramaLogo} className={classes.dogoramaLogoImage} alt="Dogorama Logo"></img>
                            </div>
                        </Grid>
                }
                <Grid item xs={12}>
                    {showProduktInfos && <ProduktDevMobile />}
                </Grid>
            </Grid >
        </React.Fragment>
);
}

export default AppHeaderMobile;